$(function () {
  if (!customElements.get('member-redeem')) {
    customElements.define(
      'member-redeem',
      class memberRedeem extends HTMLElement {
        constructor() {
          super();
          this.container = null;
          this.pointsExchangeId = null;
          this.discountType = 1;
          this.code = null;
          this.points = 0;
          this.memberRedeemListItemCopy = null;
          this.stop = false;
          this.token =
            'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1aWQiOjkwMDAwMTY4MywiYWNjZXNzIjoiYWNjZXNzIiwiZXhwIjoxOTAwODA4NTgyfQ.6hdmN-fLW-pOBoQQsGn1DO2JmV8odkekYh2_aH4Rwak';
        }
        async connectedCallback() {
          this.init();
          const memberRedeemModal = $(this.querySelector('.member-redeem-modal'));
          const closeBtn = memberRedeemModal.find('.member-redeem-modal-close');
          closeBtn.on('click', () => {
            this.closeModal();
          });
          const memberRedeemModalBtnCancel = memberRedeemModal.find('.member-redeem-modal-btn-cancel');
          memberRedeemModalBtnCancel.on('click', () => {
            this.closeModal();
          });
          const memberRedeemModalBtnRedeem = memberRedeemModal.find('.member-redeem-modal-btn-redeem').find('button');
          memberRedeemModalBtnRedeem.on('click', async () => {
            if (this.stop) {
              return;
            }
            memberRedeemModalBtnRedeem.attr('data-show-loading', 'true');
            const res = await this.redeem();
            memberRedeemModalBtnRedeem.attr('data-show-loading', 'false');
            if (res?.discountCode) {
              this.code = res.discountCode;
              const memberRedeemModalCode = memberRedeemModal.find('.member-redeem-modal-code');
              memberRedeemModalCode.removeClass('hidden').find('span').text(res.discountCode);
              const memberRedeemModalPoints = memberRedeemModal.find('.member-redeem-modal-points');
              memberRedeemModalPoints.addClass('hidden');
              const redeemBtn = memberRedeemModal.find('.member-redeem-modal-btn-redeem_wrapper');
              redeemBtn.addClass('hidden');
              const redeemBtnCopy = memberRedeemModal.find('.member-redeem-modal-btn-copy');
              redeemBtnCopy.removeClass('hidden').addClass('flex');
              const redeemRules = memberRedeemModal.find('.member-redeem-rules');
              redeemRules.css('padding-bottom', '100px');
              window.litime.eventBus.publish('CHANGE_USER_POINTS_DATA', res.userInfo);
            }
          });
          const memberRedeemModalBtnCopy = memberRedeemModal.find('.member-redeem-modal-btn-copy').find('button');
          memberRedeemModalBtnCopy.on('click', () => {
            this.copy();
          });

          window.litime.eventBus.subscribe('RENDER_REDEEM_LIST', (points) => {
            this.canRedeemCoupon(points);
          });
        }

        async redeem() {
          try {
            this.stop = true;
            const res = await this.fetchRedeem({
              pointsExchangeId: this.pointsExchangeId,
            });
            this.stop = false;
            return res;
          } catch (error) {
            this.stop = false;
            window.litime.showToast('error', error.message);
          }
        }

        changeUserPoints(res) {
          const userPointData = JSON.parse(JSON.stringify(window.litime.userPointData));
          userPointData.currentPoint -= this.points;
          this.canRedeemCoupon(userPointData.currentPoint);
          window.litime.eventBus.publish('CHANGE_USER_POINTS_DATA', JSON.parse(JSON.stringify(userPointData)));
        }

        canRedeemCoupon(points) {
          const memberRedeemListItem = $(this.querySelectorAll('.member-redeem-list_item'));
          memberRedeemListItem.each((index, item) => {
            const memberRedeemBtnRedeem = $(item).find('.member-redeem_btn_redeem');
            const memberRedeemBtnDisabled = $(item).find('.member-redeem_btn_disabled');
            if (parseInt($(item).data('points')) <= points) {
              memberRedeemBtnRedeem.removeClass('hidden');
              memberRedeemBtnDisabled.addClass('hidden');
            } else {
              memberRedeemBtnRedeem.addClass('hidden');
              memberRedeemBtnDisabled.removeClass('hidden');
            }
          });
        }

        copy() {
          window.litime.copyToClipboard(this.code);
          // 跳转到首页
          const redirecturl = `/discount/${this.code}`;
          window.location.href = redirecturl;
        }

        handleScroll() {
          const memberRedeemScrollContainer = this.querySelector('.member-redeem-scroll-container');
          const memberRedeemModalBtnRedeemWrapper = this.querySelector('.member-redeem-modal-btn-redeem_wrapper');
          const memberRedeemModalBtn = this.querySelector('.member-redeem-modal-btn');
          if (
            memberRedeemScrollContainer.scrollTop + memberRedeemScrollContainer.clientHeight >=
            memberRedeemScrollContainer.scrollHeight
          ) {
            memberRedeemModalBtnRedeemWrapper.classList.add('border-t');
            memberRedeemModalBtn.style.boxShadow = 'none';
          } else {
            memberRedeemModalBtnRedeemWrapper.classList.remove('border-t');
            memberRedeemModalBtn.style.boxShadow = '0 0 4px 0px #0000001a';
          }
        }

        showModal(type, data) {
          const memberRedeemModal = $(this.querySelector('.member-redeem-modal'));
          memberRedeemModal.removeClass('hidden').addClass('flex');
          window.litime.disableScroll();
          const redeemRules = memberRedeemModal.find('.member-redeem-rules');
          redeemRules.html(data.rules).css('white-space', 'pre-wrap');
          if (type === 'redeem') {
            const redeemBtn = memberRedeemModal.find('.member-redeem-modal-btn');
            redeemBtn.removeClass('hidden').addClass('flex');
            const redeemPart = memberRedeemModal.find('.member-redeem-modal-btn-redeem_wrapper');
            redeemPart.removeClass('hidden');
            const redeemBtnCopy = memberRedeemModal.find('.member-redeem-modal-btn-copy');
            redeemBtnCopy.addClass('hidden');
            const redeemBtnHeight = redeemBtn.height();
            const redeemBtnPaddingBottom = redeemBtn.css('padding-bottom').replace('px', '');
            const redeemBtnPaddingTop = redeemBtn.css('padding-top').replace('px', '');
            redeemRules.css(
              'padding-bottom',
              `${redeemBtnHeight + +redeemBtnPaddingBottom + +redeemBtnPaddingTop + 16}px`
            );
            this.handleScroll();
          } else {
            const redeemBtn = memberRedeemModal.find('.member-redeem-modal-btn');
            redeemBtn.removeClass('flex').addClass('hidden');
            redeemRules.css('padding-bottom', '16px');
          }
          memberRedeemModal.find('.member-redeem-modal-img').attr('src', data.coverUrl);
          memberRedeemModal.find('.member-redeem-modal-title').text(data.title);
          memberRedeemModal.find('.member-redeem-modal-points').find('span').text(data.points);
          memberRedeemModal.find('.member-redeem-modal-points').removeClass('hidden');
          memberRedeemModal.find('.member-redeem-modal-code').addClass('hidden');
        }

        closeModal() {
          const memberRedeemModal = $(this.querySelector('.member-redeem-modal'));
          memberRedeemModal.addClass('hidden').removeClass('flex');
          window.litime.enableScroll();
        }
        // 获取兑换列表
        async getMemberRedeem(data) {
          const url = '/shopify/userExchange/page';
          const res = await window.litime.http.post(url, {
            data: {
              ...data,
              orderBy: 'sort',
              order: 'asc',
            },
          });
          if (res.code === 200) {
            return res.data;
          } else {
            return null;
            // throw new Error(window.i18n.error_message_timeout);
          }
        }

        // 兑换
        async fetchRedeem(data) {
          const url = '/shopify/userExchange/exchangeDiscount';
          const res = await window.litime.http.post(url, {
            data,
          });
          if (res.code === 200) {
            window.litime.showToast('success', window.i18n.redeem_success);
            return res.data;
          } else {
            throw new Error(window.i18n.redeem_error);
          }
        }

        renderRedeem(res) {
          const _this = this;
          const memberRedeemList = $(this.querySelector('.member-redeem-list'));
          let memberRedeemListItems = memberRedeemList.find('.member-redeem-list_item');
          // 复制memberRedeemListItems
          if (!this.memberRedeemListItemCopy) {
            this.memberRedeemListItemCopy = memberRedeemListItems.first().clone();
          }
          if (res.records.length === 0) {
            if (this.discountType === 1) {
              $(this.querySelector('.member-redeem-discount-empty')).removeClass('hidden');
            } else {
              $(this.querySelector('.member-redeem-product-empty')).removeClass('hidden');
            }
          } else {
            $(this.querySelector('.member-redeem-discount-empty')).addClass('hidden');
            $(this.querySelector('.member-redeem-product-empty')).addClass('hidden');
          }
          // 删除原来的
          memberRedeemList.empty();
          res.records.forEach((item) => {
            const memberRedeemListItem = this.memberRedeemListItemCopy.clone();
            memberRedeemListItem.attr('data-point-id', item.id);
            memberRedeemListItem.attr('data-points', item.usePoints);
            if (item.coverUrl) {
              memberRedeemListItem.find('.member-redeem-img').attr('src', item.coverUrl);
            }
            memberRedeemListItem.find('.member-redeem-title').text(item.exchangeName);
            const $pointsBlock = memberRedeemListItem.find('.member-redeem-points');
            $pointsBlock.find('span').first().text(item.usePoints);
            if (item.usePoints <= 1) {
              const $label = $pointsBlock.find('.member-redeem-points-label');
              const labelText = $label.text().trim();
              if (labelText.length > 0 && labelText.toLowerCase().endsWith('s')) {
                $label.text(labelText.slice(0, -1));
              }
            }
            memberRedeemList.append(memberRedeemListItem);
          });
          memberRedeemList.addClass('flex').removeClass('hidden').addClass('max-xs:grid');
          memberRedeemListItems = memberRedeemList.find('.member-redeem-list_item');
          if (window.litime?.userPointData) {
            const userPointData = JSON.parse(JSON.stringify(window.litime?.userPointData));
            this.canRedeemCoupon(userPointData?.currentPoint);
          }
          // jq获取自定义css变量·
          const count = getComputedStyle(memberRedeemList[0]).getPropertyValue('--count');
          //   memberRedeemList.css('grid-template-rows', `none`);
          memberRedeemListItems.each((index, item) => {
            if (index < count) {
              $(item).css('display', 'flex');
            } else {
              $(item).css('display', 'none');
            }
            const redeemBtn = $(item).find('.member-redeem_btn_redeem');
            const rules = res.records[index].ruleDesc;
            const title = res.records[index].exchangeName;
            const points = res.records[index].usePoints;
            const coverUrl = res.records[index].coverUrl;
            redeemBtn.on('click', () => {
              if (window.customer) {
                _this.pointsExchangeId = $(item).attr('data-point-id');
                _this.points = points;
                _this.showModal('redeem', {
                  rules,
                  title,
                  points,
                  coverUrl,
                });
              } else {
                window.litime.eventBus.publish('LOGIN');
              }
            });

            const rulesBtn = $(item).find('.member-redeem-rules-btn');
            rulesBtn.on('click', () => {
              _this.rules = res.records[index].ruleDesc;
              _this.showModal('rules', {
                rules,
                title,
                points,
                coverUrl,
              });
            });
          });

          const viewMoreRedeem = $(this.querySelector('.view-more_redeem'));
          if (memberRedeemListItems.length <= count) {
            viewMoreRedeem.addClass('hidden');
          } else {
            viewMoreRedeem.removeClass('hidden');
          }
          viewMoreRedeem.on('click', () => {
            memberRedeemListItems.css('display', 'block');
            viewMoreRedeem.addClass('hidden');
          });
        }

        showLoading() {
          const memberRedeemList = $(this.querySelector('.member-redeem-list'));
          memberRedeemList.addClass('hidden').removeClass('flex').removeClass('max-xs:grid');
          const memberRedeemLoading = $(this.querySelector('.member-redeem-loading'));
          memberRedeemLoading.removeClass('hidden').addClass('flex');
          $(this.querySelector('.member-redeem-discount-empty')).addClass('hidden');
          $(this.querySelector('.member-redeem-product-empty')).addClass('hidden');
        }

        hideLoading() {
          const memberRedeemLoading = $(this.querySelector('.member-redeem-loading'));
          memberRedeemLoading.addClass('hidden').removeClass('flex');
        }

        init() {
          const _this = this;
          this.showLoading();
          this.getMemberRedeem({
            discountType: this.discountType,
            status: 1,
            page: 1,
            pageSize: 999,
          })
            .then((res) => {
              this.hideLoading();
              _this.renderRedeem(res);
            })
            .catch((err) => {
              this.hideLoading();
              if (window.litime?.showToast) {
                window.litime.showToast('error', window.i18n.request_failed);
              }
              if (_this.discountType === 1) {
                $(this.querySelector('.member-redeem-discount-empty')).removeClass('hidden');
              } else {
                $(this.querySelector('.member-redeem-product-empty')).removeClass('hidden');
              }
            });
          const discountTab = $(this.querySelectorAll('[data-discount-type]'));
          discountTab.on('click', function () {
            const discountType = $(this).attr('data-discount-type');
            if (_this.discountType != discountType) {
              _this.showLoading();
              _this.discountType = discountType;
              _this
                .getMemberRedeem({
                  discountType: discountType,
                  status: 1,
                  page: 1,
                  pageSize: 999,
                })
                .then((res) => {
                  _this.hideLoading();
                  _this.renderRedeem(res);
                  discountTab.removeClass('member-redeem-tab-item_active');
                  $(this).addClass('member-redeem-tab-item_active');
                })
                .catch((err) => {
                  _this.hideLoading();
                  window.litime.showToast('error', window.i18n.request_failed);
                  if (_this.discountType === 1) {
                    $(this.querySelector('.member-redeem-discount-empty')).removeClass('hidden');
                  } else {
                    $(this.querySelector('.member-redeem-product-empty')).removeClass('hidden');
                  }
                });
            }
          });
        }
      }
    );
  }
});
